import PropTypes from 'prop-types'
import React from 'react'
import { observer, inject } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import ModalButton from '../utils/modalButton'
import BasicCItemsForm from './parts/basic_info'
import EditView from 'bstrap-react-mobx-admin/new_src/view/edit'
import ExpensesEdit from '../contracts/parts/expenses'
import ItemSharesEdit from '../contracts/parts/item_shares'
import RightsCostsEdit from './parts/right_costs'
import RightsEdit from '../contracts/parts/rights'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import TypeAheadInput from 'bstrap-react-mobx-admin/new_src/input/typeahead'
import { Helmet } from 'react-helmet'
import { Tabs, Tab, Button } from 'react-bootstrap'
import HelpOverlay from '../utils/helpOverlay'

const ContractItemEditForm = ({ store }) => {
  const subentities = store.cv.subentities
  const updateField = store.cv.updateData.bind(store.cv)
  const record = store.cv.record
  const errors = store.cv.errors
  const handleActive = tab => {
    store.lastCITab = tab
  }

  const link = store.router.params.entname === 'contract' ? (
    <TypeAheadInput
      attr={'film_id'} record={record} onChange={updateField}
      label={store.__('film (selecting a film will change the "Contract title")')}
      placeholder='start writing to get suggesions ...'
      options={store.options.get('films').map(i => ({ value: i.id, label: i.title }))}
      errors={errors}
      emptyLabel='no match' renderMenuItemChildren={(option, props) => (
        <span key={option.id}>{option.title}</span>
      )} />
  ) : (
    <TypeAheadInput
      attr='contract_id' record={record} onChange={updateField}
      label={store.__('contract name')}
      errors={errors}
      placeholder='start writing to get suggesions ...'
      options={store.options.get('contracts').map(i => ({ value: i.id, label: i.name }))}
      emptyLabel='no match' renderMenuItemChildren={(option, props) => (
        <span key={option.id}>{option.name}</span>
      )} />
  )

  return (
    <Tabs defaultActiveKey={store.lastCITab || 1} onSelect={handleActive} id='contract_tabs'>
      <Tab eventKey={1} title={
        <div>
          {store.__('Settings')}
          <HelpOverlay store={store} path='contractitems/settings' />
        </div>}>
        <div className='row'>
          <div className='col-xs-12'>
            {link}
            <TextInput label={store.__('contract title')} attr={'title'} record={record}
              onChange={updateField} errors={errors} />
            <TextInput label={store.__('studio asset ID')} attr={'studio_asset_id'}
              record={record} onChange={updateField} errors={errors} />
            <BasicCItemsForm store={store} updateField={updateField} record={record} errors={errors} />
          </div>
        </div>
      </Tab>
      <Tab eventKey={2} title={
        <div>
          {store.__('Rights')}
          <HelpOverlay store={store} path='contractitems/rights' />
        </div>
      }>
        <RightsEdit store={store}
          state={subentities.rights} items={record.get('rights')}
          attr={'rights'} />
      </Tab>
      <Tab eventKey={3} title={
        <div>
          {store.__('Costs')}
          <HelpOverlay store={store} path='contractitems/costs' />
        </div>
      }>
        <ExpensesEdit store={store} state={subentities.limits}
          items={record.get('limits')} attr={'limits'} />
      </Tab>
      <Tab eventKey={4} title={
        <div>
          {store.__('Shares')}
          <HelpOverlay store={store} path='contractitems/shares' />
        </div>
      }>
        {
          store.cv.record.get('shares') ? (
            <div className='col-xs-12'>
              <Button bsStyle='primary' block onClick={() => store.cv.handleSharesSync()}>
                {store.__('Synchronize shares')}
              </Button>
            </div>
          ) : null
        } {
          store.cv.record.get('shares') ? (
            <div className='col-xs-12' >
              <ItemSharesEdit store={store}
                state={subentities.shares}
                items={record.get('shares')} />
            </div>
          ) : null
        }
      </Tab>
      <Tab eventKey={5} title={
        <div>
          {store.__('Rights costs')}
          <HelpOverlay store={store} path='contractitems/rights_costs' />
        </div>
      }>
        {
          store.cv.record.get('rightsCosts')
            ? (<div className='col-xs-12' >
              <RightsCostsEdit
                store={store}
                state={subentities.rightsCosts}
                items={record.get('rightsCosts')} />
            </div>
            ) : null
        }
      </Tab>
    </Tabs>
  )
}
ContractItemEditForm.propTypes = {
  store: PropTypes.object.isRequired
}

const CItemEditView = ({ store }) => {
  //
  if (!store.hasRight(defaultConst.ENTNAMES.CONTRACTITEMS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const entity = store.router.params.entname
  const record = store.cv.record
  const eid = parseInt(store.router.params.eid)
  const getContractName = () => {
    const found = store.options.get('contracts').find(i => i.id === eid)
    return found ? found.name : ''
  }
  const getFilmName = () => {
    const found = store.options.get('films').find(i => i.id === eid)
    return found ? found.title : ''
  }

  const entityTitle = entity === 'film' ? store.__(linkConst.LINK_FILMS_TITLE) : store.__(linkConst.LINK_CONTRACTS_TITLE)
  const itemName = entity === 'film' ? getFilmName() : getContractName()
  const itemTitle = entity === 'film' ? store.__(linkConst.LINK_FILM_ITEMS_TITLE) : store.__(linkConst.LINK_CONTRACT_ITEMS_TITLE)
  const createEditTitle = (type) => (
    <span>
      <span className='first-to-uppercase'>{entityTitle}</span>
      {defaultConst.TITLE_DIVIDER}
      <span className='text-primary text-strong'>{itemName}</span>
      {defaultConst.TITLE_DIVIDER}
      {itemTitle}
      {defaultConst.TITLE_DIVIDER}
      {type === 'create'
        ? store.__(defaultConst.TITLE_CREATE)
        : <span className='text-primary text-strong'> {store.cv.record.has('title') && store.cv.record.get('title')} </span>
      }
    </span>
  )

  const filmButton = store.hasRight(defaultConst.ENTNAMES.FILMS) && record.has('film_id') &&
    <div key='1' className='buttons-vertical-align' style={{ display: 'inline-block' }}>
      <HelpOverlay helpContent='Show film associated with this title'><Button
        onClick={() => store.goTo('entity_detail', { entityname: 'films', id: record.get('film_id') })}
        bsStyle='info'>
        <span className='glyphicon glyphicon-share-alt' />&nbsp; {store.__(linkConst.LINK_FILM_DETAIL_TITLE)}
      </Button></HelpOverlay>
    </div>

  const contractButton = store.hasRight(defaultConst.ENTNAMES.CONTRACTS) && record.has('contract_id') &&
    <div key='1' className='buttons-vertical-align' style={{ display: 'inline-block' }}>
      <HelpOverlay helpContent='Show contract associated with this film'><Button
        onClick={() => store.goTo('entity_detail', { entityname: 'contracts', id: record.get('contract_id') })}
        bsStyle='info'>
        <span className='glyphicon glyphicon-share-alt' />&nbsp; {store.__(linkConst.LINK_CONTRACT_DETAIL_TITLE)}
      </Button></HelpOverlay>
    </div>

  return (
    <EditView
      store={store.cv}
      enabled={store.hasRight(defaultConst.ENTNAMES.CONTRACTITEMS, 'w')}
      onReturn2list={store.cv.back.bind(store.cv)}
      options={{
        cancelText: () => defaultConst.TITLE_CANCEL,
        saveAndReturnText: () => defaultConst.TITLE_SAVE_RETURN,
        saveText: () => defaultConst.TITLE_SAVE,
        createTitle: () => createEditTitle('create'),
        editTitle: () => createEditTitle('edit'),
        customActionButtons: [
          (entity === 'film' ? contractButton : filmButton),
          <ModalButton key='2' store={store} modal={store.modalEntity} title={store.cv.record.get('name')} />
        ]
      }} >
      <ContractItemEditForm store={store} />
      <Helmet title={store.__(itemTitle).concat(defaultConst.HTML_DIVIDER) + (store.cv.record.get('id')
        ? (store.cv.record && store.cv.record.has('title')
          ? store.cv.record.get('title')
          : store.__(defaultConst.TITLE_EDIT))
        : store.__(defaultConst.TITLE_CREATE))} />
    </EditView>
  )
}
CItemEditView.propTypes = {
  store: PropTypes.object.isRequired
}

export default inject('store')(observer(CItemEditView))
